var _defs, _g, _polygon, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHackettDwcMatrixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1500 1500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        fill: none;\n        stroke: #CC3333;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2, .cls-4, .cls-5, .cls-6, .cls-8 {\n        stroke-width: 8px;\n      }\n\n      .cls-2 {\n        stroke-dasharray: 39.99 39.99;\n      }\n\n      .cls-3 {\n        stroke-width: 30px;\n      }\n\n      .cls-4 {\n        stroke-dasharray: 36.82 36.82;\n      }\n\n      .cls-5 {\n        stroke-dasharray: 39.64 39.64;\n      }\n\n      .cls-6 {\n        stroke-dasharray: 38.77 38.77;\n      }\n\n      .cls-7 {\n        stroke-width: 3px;\n      }\n\n      .cls-8 {\n        stroke-dasharray: 38.74 38.74;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "115.03 543.55 115.03 956.03 357.48 1289.73 749.76 1417.19 1142.05 1289.73 1384.5 956.03 1384.5 543.55 1142.05 209.85 749.76 82.39 357.48 209.85 115.03 543.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "241.98 584.8 241.98 914.78 435.93 1181.74 749.76 1283.71 1063.59 1181.74 1257.55 914.78 1257.55 584.8 1063.59 317.84 749.76 215.87 435.93 317.84 241.98 584.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "368.92 626.05 368.92 873.54 514.39 1073.76 749.76 1150.23 985.14 1073.76 1130.61 873.54 1130.61 626.05 985.14 425.83 749.76 349.35 514.39 425.83 368.92 626.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "502.22 669.36 502.22 830.23 596.77 960.37 749.76 1010.08 902.76 960.37 997.31 830.23 997.31 669.36 902.76 539.22 749.76 489.51 596.77 539.22 502.22 669.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "625.99 709.58 625.99 790.01 673.27 855.08 749.76 879.94 826.26 855.08 873.54 790.01 873.54 709.58 826.26 644.51 749.76 619.65 673.27 644.51 625.99 709.58"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1322.5 572.5 749.76 152.15 394.5 262.5 180.45 572.5 180.5 942.5 398.74 1235.92 749.76 1344.74 1099.6 1235.92 1257.55 914.78 1322.5 572.5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1288.99 934.45 1304.11 922.94 1304.11 903.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "1304.11 864.3 1304.11 570.36 1135.88 297.54"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1125.47 280.67 1115.5 264.5 1096.93 260.49"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1060.93 252.73 749.76 185.63 431.07 254.59"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "413.07 258.48 394.5 262.5 386.79 279.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "370.56 316.42 241.98 606.08 187.51 904.14"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "183.92 923.81 180.5 942.5 196.02 953.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 227.68,
    y1: 975.84,
    x2: 718.42,
    y2: 1322.59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "734.25 1333.78 749.76 1344.74 764.88 1333.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 795.71,
    y1: 1309.78,
    x2: 1273.57,
    y2: 946.17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHackettDwcMatrixIcon);
export default __webpack_public_path__ + "static/media/hackett-dwc-matrix-icon.8c73cad20c6d57ae7723710cb2324105.svg";
export { ForwardRef as ReactComponent };